var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$store.getters.authenticated && _vm.$route.path.includes('/Registrieren/'))?[_c('Register')]:(!_vm.$store.getters.authenticated)?[_c('Login')]:[_c('Navbar'),_c('router-view',{staticClass:"mt-4 mb-4"})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }